<style lang="scss" scoped>


</style>

<template>
    <Modal ref="modal">
        <template v-slot:title>
            Neuen Schlag anlegen
        </template>
        
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Schlagname</label>
                <input type="text" v-model="label" class="form-control" name="example-text-input" placeholder="Name des Schlags">
            </div>           
        </div>
        
        <Alert type="danger" :show="alert.emptyProfileName" :timeout="3000">
            <template v-slot:title>Schlagname</template>
            Bitte geben Sie einen Schlagnamen an
        </Alert>
    
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Kultur</label>
                <select v-model="cropId" class="form-select">
                    <!-- Feste Option ohne Gruppe -->
                    <option :value="null">Bitte auswählen</option>

                    <!-- Dynamische Gruppen -->
                    <optgroup
                        v-for="(group, groupLabel) in groupedCropList"
                        :key="groupLabel"
                        :label="groupLabel"
                    >
                        <option
                            v-for="option in group"
                            :key="option.id"
                            :value="option.id"
                        >
                            {{ option.label }}
                        </option>
                    </optgroup>
                </select>
          </div>           
        </div>
        
        <Alert type="danger" :show="alert.emptyCropName" :timeout="3000">
            <template v-slot:title>Kultur</template>
            Bitte geben Sie eine Kultur an
        </Alert>
        
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Schlaggröße in Hektar</label>
                <FloatInput v-model:value="area" :imaskOptions="{mask:'0[00]{,}000 h\\a',overwrite: true, eager: true, lazy: false}"
                :digits="3" placeholder="Fläche des Schlags in ha" >
                </FloatInput>
            </div>           
        </div>
        
        <Alert type="danger" :show="alert.areaEmpty" :timeout="3000">
            <template v-slot:title>Schlaggröße fehlt</template>
            Bitte geben Sie die Schlaggröße in Hektar an. Bitte beachten Sie, dass Schlaggröße später nicht mehr verändert werden kann
        </Alert> 
        
        <Alert type="danger" :show="alert.area">
            <template v-slot:title>Bitte bachten Sie</template>
                Die Schlaggröße kann später nicht mehr verändert werden. Zum Anlegen des neuen 
                Schlags mit einer Größe von <b>{{ area ? area.toFixed(3).replace('.',',') : '' }} ha</b> 
                klicken Sie bitte jetzt auf „+ Schlag anlegen".
        </Alert> 

        <template v-if="selectedCrop.isPerennialCrop === true">
            <div class="row mt-3 mb-2">
                <div class="col-12">
                    <label class="form-label">Erstes Vegetationsjahr</label>
                    <select v-model="firstVegetationYear" class="form-select">
                         <option v-for="option in firstVegetationYearList" v-bind:key="option" v-bind:value="option">{{ option }}</option>
                    </select>
                </div>           
            </div>
        </template>
        
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">{{ selectedCrop.isPerennialCrop === true ? 'Berechnungsjahr' : 'Jahr' }}</label>
                <select v-model="year" class="form-select">
                    <option v-for="option in profileYearList" v-bind:key="option" v-bind:value="option">{{ option }}</option>
                </select>
            </div>           
        </div>
        <Alert type="danger" :show="alert.emptyProfileYear" :timeout="3000">
            <template v-slot:title>{{ selectedCrop.isPerennialCrop === true ? 'Berechnungsjahr' : 'Jahr' }}</template>
            Bitte wählen Sie ein {{ selectedCrop.isPerennialCrop === true ? 'Berechnungsjahr' : 'Jahr' }} für den Schlag
        </Alert>
        
                
        <template v-slot:footer>
            <a href="#" class="btn btn-light link-secondary" @click="closeModal" >
              Abbrechen
            </a>
            <a href="#" class="btn btn-success ms-auto text-white bg-green" @click="submit">
              <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                Schlag anlegen
            </a>
        </template>
    </Modal>
</template>

<script>
import axios from 'axios';
import * as dayjs from 'dayjs';

import Modal from '@/components/Modal.vue';
import Alert from '@/components/Alert.vue';
import FloatInput from '@/components/input/FloatInput.vue';

export default {
    name: 'New Profile Modal',
    components: {
        Modal,
        Alert,
        FloatInput
    },
    inject: [
        'state',
        'config'
    ],
    props: {
       profileYear: {
            type: Number
       }
    },
    data: function () {
        return {
            label: '',
            area: null,
            year: null,
            firstVegetationYear: null,
            loading: false,
            cropId: null,
            cropList_: [],
            alert: {
                emptyProfileName: false,
                emptyCropName: false,
                areaEmpty: false,
                area: false,
                emptyProfileYear: false
            }
        }
    },
    computed: {
        profileYearList: function () {
            let profile_years = [];
            let startDate = parseInt(dayjs().subtract(10, 'year').format('YYYY'));
            let endDate = parseInt(dayjs().subtract(5, 'day').format('YYYY'));
            
            if (this.selectedCrop.isPerennialCrop === true && this.firstVegetationYear)  {
                startDate = parseInt(this.firstVegetationYear);
            }
        
            for (let y = startDate; y <= endDate; y++) {
                profile_years.push(y);
			}
            
            return profile_years.reverse();
        },
        firstVegetationYearList: function () {
            let first_vegetation_year_list = [];
            let startDate = parseInt(dayjs().subtract(10, 'year').format('YYYY'));
            let endDate = parseInt(dayjs().subtract(5, 'day').format('YYYY'));
        
            for (let y = startDate; y <= endDate; y++) {
                first_vegetation_year_list.push(y);
			}
            return first_vegetation_year_list.reverse();
        },
        cropList: function () {
            return [
               
            ].concat(this.cropList_);
        },
        groupedCropList: function () {
            return this.cropList.reduce((groups, item) => {
                if (!groups[item.groupLabel]) {
                    groups[item.groupLabel] = [];
                }
                groups[item.groupLabel].push(item);
                return groups;
            }, {});
        },
        selectedCrop: function () {
            return this.cropList.find(function (item) {
                return item.id === this.cropId;
            }.bind(this)) || {};
        }
    },
    methods: {
        submit: function () {
            if (this.validateForm()) {
                this.$emit('submit', {
                    label: this.label,
                    area: Math.round(this.area * 10000.0),
                    cropId: this.cropId,
                    year: this.year,
                    firstVegetationYear: this.firstVegetationYear
                });
                this.label = '';
                this.closeModal();
            }
        },
        openModal: function () {
            this.$refs.modal.openModal();            
        },
        closeModal: function () {
            this.$refs.modal.closeModal();            
        },
        validateForm: function () {
           this.alert.emptyProfileName = false;
           this.alert.emptyCropName = false;
           this.alert.emptyProfileYear = false;
           this.alert.areaEmpty = false;
            
           if ( String(this.label).trim() === '' ) {
                this.$nextTick(function() { 
                    this.alert.emptyProfileName = true;
                });
                return false;
           }
           
           if ( ! this.cropId ) {
                this.$nextTick(function() { 
                    this.alert.emptyCropName = true;
                });
                return false;
           }
           
           if ( !this.profileYearList.includes(this.year)) {
                this.$nextTick(function() { 
                    this.alert.emptyProfileYear = true;
                });
                return false;
           }
           
           if (!this.area) {
                this.$nextTick(function() { 
                    this.alert.areaEmpty = true;
                });
                return false;
           }
           
           if (this.alert.area === false ) {
                this.$nextTick(function() { 
                    this.alert.area = true;
                 });
                return false;
           }
            
            
           return true;
        },
        fetchData: function (callback) {
            let self = this;
            
            let query = {
                query: `
                    query {
                        crops {
                            id
                            label
                            groupLabel
                            isPerennialCrop
                            isRowCrop
                        },
                        loggedIn
                    }
                `,      
                variables: {
                    profileId : self.state.profile.id
                }           
            }
            
            let request = Object.assign({}, self.config.request,
            {
                data: query,
            });
           
            self.loading = true;
            
            axios(request).then( function (response) {
                let data = response.data.data;
            
                if ( data !== null ) {
                    self.cropList_ = data.crops;
                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
                
            });
        }
    },
    watch: {
        profileYear: function () {
            this.year = this.profileYear;
        },
        profileYearList: {
            handler: function (newList) {
                // Wenn Liste leer ist → year auf null setzen
                if (!newList || newList.length === 0) {
                    this.year = null;
                    return;
                }

                // Prüfen, ob aktuelles year noch existiert
                var exists = newList.includes(this.year);

                // Wenn nicht → erstes Element auswählen
                if (!exists) {
                    this.year = newList[0];
                }
            },
            immediate: true
        }       
    },
    created: function () {
        
    },
    mounted: function () {
        this.year = this.profileYear;
		this.year = parseInt(dayjs().subtract(5, 'day').format('YYYY'));
        this.firstVegetationYear = parseInt(dayjs().subtract(5, 'day').format('YYYY'));
        this.fetchData();
    }
}
</script>